import { css, Global } from '@emotion/react';

// NOTE: These styles were generated from the SVG Gator application and target individual SVG components
// found in the `bubbles.svg` file
export const AnimationStyle = () => {
	return (
		<Global
			styles={css`
				#ez0Fy9mcjY42 {
					animation: ez0Fy9mcjY42_c_o 6000ms linear infinite normal forwards;
				}

				@keyframes ez0Fy9mcjY42_c_o {
					0% {
						opacity: 0;
					}

					16.666667% {
						opacity: 0;
					}

					33.333333% {
						opacity: 1;
					}

					50% {
						opacity: 1;
					}

					83.333333% {
						opacity: 1;
					}

					100% {
						opacity: 0;
					}
				}

				#ez0Fy9mcjY43_to {
					animation: ez0Fy9mcjY43_to__to 6000ms linear infinite normal forwards;
				}

				@keyframes ez0Fy9mcjY43_to__to {
					0% {
						transform: translate(99.252498px, 87.000199px);
						animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
					}

					33.333333% {
						transform: translate(96.252498px, 87.000199px);
					}

					50% {
						transform: translate(146.678114px, 87.000199px);
					}

					66.666667% {
						transform: translate(200.678114px, 87.000199px);
					}

					83.333333% {
						transform: translate(212.678114px, 87.000199px);
					}

					100% {
						transform: translate(212.678114px, 87.000199px);
					}
				}

				#ez0Fy9mcjY43_ts {
					animation: ez0Fy9mcjY43_ts__ts 6000ms linear infinite normal forwards;
				}

				@keyframes ez0Fy9mcjY43_ts__ts {
					0% {
						transform: scale(1.90003, 1.900033);
					}

					33.333333% {
						transform: scale(1.90003, 1.900033);
					}

					50% {
						transform: scale(3.694613, 3.694618);
					}

					66.666667% {
						transform: scale(1.833362, 1.833364);
					}

					83.333333% {
						transform: scale(0.981365, 0.981365);
					}

					100% {
						transform: scale(0.981365, 0.981365);
					}
				}

				#ez0Fy9mcjY44_to {
					animation: ez0Fy9mcjY44_to__to 6000ms linear infinite normal forwards;
				}

				@keyframes ez0Fy9mcjY44_to__to {
					0% {
						offset-distance: 0%;
					}

					16.666667% {
						offset-distance: 20.560023%;
					}

					33.333333% {
						offset-distance: 39.97045%;
					}

					50% {
						offset-distance: 47.27386%;
					}

					66.666667% {
						offset-distance: 47.27386%;
					}

					83.333333% {
						offset-distance: 94.342741%;
					}

					100% {
						offset-distance: 100%;
					}
				}

				#ez0Fy9mcjY44_ts {
					animation: ez0Fy9mcjY44_ts__ts 6000ms linear infinite normal forwards;
				}

				@keyframes ez0Fy9mcjY44_ts__ts {
					0% {
						transform: scale(1, 1);
					}

					16.666667% {
						transform: scale(2.007756, 2.007736);
					}

					33.333333% {
						transform: scale(0.950009, 0.950001);
					}

					50% {
						transform: scale(0.499989, 0.499984);
					}

					66.666667% {
						transform: scale(0.499989, 0.499984);
					}

					83.333333% {
						transform: scale(1.003241, 1.003235);
					}

					100% {
						transform: scale(1.003241, 1.003235);
					}
				}

				#ez0Fy9mcjY44 {
					animation: ez0Fy9mcjY44_c_o 6000ms linear infinite normal forwards;
				}

				@keyframes ez0Fy9mcjY44_c_o {
					0% {
						opacity: 1;
					}

					50% {
						opacity: 1;
					}

					66.666667% {
						opacity: 0;
					}

					83.333333% {
						opacity: 0;
					}

					91.666667% {
						opacity: 0.14;
					}

					100% {
						opacity: 1;
					}
				}

				#ez0Fy9mcjY46_to {
					animation: ez0Fy9mcjY46_to__to 6000ms linear infinite normal forwards;
				}

				@keyframes ez0Fy9mcjY46_to__to {
					0% {
						transform: translate(144.774561px, 88.036374px);
					}

					16.666667% {
						transform: translate(195.2px, 88px);
					}

					33.333333% {
						transform: translate(214.225832px, 88px);
					}

					50% {
						transform: translate(214.225832px, 88px);
					}

					66.666667% {
						transform: translate(101.225832px, 88px);
					}

					83.333333% {
						transform: translate(97.225832px, 88px);
					}

					100% {
						transform: translate(144.77px, 88px);
					}
				}

				#ez0Fy9mcjY46_ts {
					animation: ez0Fy9mcjY46_ts__ts 6000ms linear infinite normal forwards;
				}

				@keyframes ez0Fy9mcjY46_ts__ts {
					0% {
						transform: scale(1, 1);
					}

					16.666667% {
						transform: scale(0.475, 0.475);
					}

					33.333333% {
						transform: scale(0.229831, 0.229831);
					}

					50% {
						transform: scale(0.229831, 0.229831);
					}

					66.666667% {
						transform: scale(0.449738, 0.449738);
					}

					100% {
						transform: scale(1.000619, 1.000617);
					}
				}

				#ez0Fy9mcjY46 {
					animation: ez0Fy9mcjY46_c_o 6000ms linear infinite normal forwards;
				}

				@keyframes ez0Fy9mcjY46_c_o {
					0% {
						opacity: 1;
					}

					33.333333% {
						opacity: 1;
					}

					50% {
						opacity: 0;
					}

					66.666667% {
						opacity: 0;
					}

					83.333333% {
						opacity: 1;
					}

					100% {
						opacity: 1;
					}
				}

				#ez0Fy9mcjY48_to {
					animation: ez0Fy9mcjY48_to__to 6000ms linear infinite normal forwards;
				}

				@keyframes ez0Fy9mcjY48_to__to {
					0% {
						transform: translate(180.71781px, 88.000008px);
					}

					16.666667% {
						transform: translate(210.99968px, 88px);
					}

					33.333333% {
						transform: translate(210.99968px, 88px);
					}

					50% {
						transform: translate(100.99968px, 88px);
					}

					66.666667% {
						transform: translate(98.872668px, 88px);
					}

					83.333333% {
						transform: translate(131.872668px, 88px);
					}

					100% {
						transform: translate(181.872668px, 87.761085px);
					}
				}

				#ez0Fy9mcjY48_ts {
					animation: ez0Fy9mcjY48_ts__ts 6000ms linear infinite normal forwards;
				}

				@keyframes ez0Fy9mcjY48_ts__ts {
					0% {
						transform: scale(1, 1);
					}

					16.666667% {
						transform: scale(0.499984, 0.499984);
					}

					33.333333% {
						transform: scale(0.499984, 0.499984);
					}

					50% {
						transform: scale(0.999999, 0.999999);
					}

					66.666667% {
						transform: scale(0.999999, 0.999999);
					}

					83.333333% {
						transform: scale(2.072672, 2.072672);
					}

					100% {
						transform: scale(0.963417, 0.963417);
					}
				}

				#ez0Fy9mcjY48 {
					animation: ez0Fy9mcjY48_c_o 6000ms linear infinite normal forwards;
				}

				@keyframes ez0Fy9mcjY48_c_o {
					0% {
						opacity: 1;
					}

					16.666667% {
						opacity: 1;
					}

					33.333333% {
						opacity: 0;
					}

					50% {
						opacity: 0;
					}

					66.666667% {
						opacity: 1;
					}

					100% {
						opacity: 1;
					}
				}

				#ez0Fy9mcjY410_to {
					animation: ez0Fy9mcjY410_to__to 6000ms linear infinite normal forwards;
				}

				@keyframes ez0Fy9mcjY410_to__to {
					0% {
						transform: translate(205px, 88px);
					}

					25% {
						transform: translate(205px, 88px);
					}

					33.333333% {
						transform: translate(95px, 88px);
					}

					50% {
						transform: translate(100.369077px, 88.217572px);
					}

					66.666667% {
						transform: translate(136.918027px, 88.217572px);
					}

					83.333333% {
						transform: translate(182.918027px, 88.217572px);
					}

					100% {
						transform: translate(201.918027px, 88.217572px);
					}
				}

				#ez0Fy9mcjY410_ts {
					animation: ez0Fy9mcjY410_ts__ts 6000ms linear infinite normal forwards;
				}

				@keyframes ez0Fy9mcjY410_ts__ts {
					0% {
						transform: scale(1, 1);
					}

					33.333333% {
						transform: scale(1, 1);
					}

					50% {
						transform: scale(2.005437, 2.005437);
					}

					66.666667% {
						transform: scale(3.958615, 3.958615);
					}

					83.333333% {
						transform: scale(1.984301, 1.984301);
					}

					100% {
						transform: scale(1.154963, 1.154963);
					}
				}

				#ez0Fy9mcjY410 {
					animation: ez0Fy9mcjY410_c_o 6000ms linear infinite normal forwards;
				}

				@keyframes ez0Fy9mcjY410_c_o {
					0% {
						opacity: 0.96;
					}

					25% {
						opacity: 0;
					}

					33.333333% {
						opacity: 0;
					}

					50% {
						opacity: 1;
					}

					100% {
						opacity: 1;
					}
				}

				#ez0Fy9mcjY412_to {
					animation: ez0Fy9mcjY412_to__to 6000ms linear infinite normal forwards;
				}

				@keyframes ez0Fy9mcjY412_to__to {
					0% {
						transform: translate(103.345295px, 88.021625px);
					}

					16.666667% {
						transform: translate(102.345294px, 88.000002px);
					}

					33.333333% {
						transform: translate(142.912887px, 88.091936px);
					}

					50% {
						transform: translate(186.333641px, 88px);
					}

					66.666667% {
						transform: translate(213.333641px, 88px);
					}

					100% {
						transform: translate(213.333641px, 88px);
					}
				}

				#ez0Fy9mcjY412_ts {
					animation: ez0Fy9mcjY412_ts__ts 6000ms linear infinite normal forwards;
				}

				@keyframes ez0Fy9mcjY412_ts__ts {
					0% {
						transform: rotate(-180deg) scale(0.500215, 0.500215);
					}

					16.666667% {
						transform: rotate(-180deg) scale(0.500215, 0.500215);
					}

					33.333333% {
						transform: rotate(-180deg) scale(0.999999, 0.999999);
					}

					50% {
						transform: rotate(-180deg) scale(0.509232, 0.509232);
					}

					66.666667% {
						transform: rotate(-180deg) scale(0.254607, 0.254607);
					}

					100% {
						transform: rotate(-180deg) scale(0.254607, 0.254607);
					}
				}

				#ez0Fy9mcjY412 {
					animation: ez0Fy9mcjY412_c_o 6000ms linear infinite normal forwards;
				}

				@keyframes ez0Fy9mcjY412_c_o {
					0% {
						opacity: 0;
					}

					16.666667% {
						opacity: 1;
					}

					66.666667% {
						opacity: 1;
					}

					83.333333% {
						opacity: 0;
					}

					100% {
						opacity: 0;
					}
				}
			`}
		/>
	);
};
